import React, { Component } from 'react'
import { InternshipDetailById, updateInternship } from '../../action/jobs';
import PostAJob from '../../old_Components/Campus/PostInternship'
import constant from '../../constant';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import Shimmer from '../../old_Components/Common/Shimmer';
import AsideRightMenu from '../../old_Components/Dashboard/AsideRightMenu';


export default class EditJob extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
            JOB_ID: undefined,
            showLoader: false,
        }
    }

    componentDidMount() {
        document.title = constant.title.EditRegularJob
        this.regularJobById()
    }

    regularJobById = () => {
        const qParam = queryString.parse(this.props?.location?.search)
        this.setState({ JOB_ID: qParam.i })
        InternshipDetailById(qParam.i).then((res) => {
            console.log(res.result,"InternshipDetailById");
            if (res.status) {
                this.setState({ data: res.result })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        })
    }

    onSubmit = (model) => {
        this.setState({ showLoader: true })
        updateInternship(model).then((res) => {
            this.props.history.push(constant.component.campusInternshipList.url + '?f=ALL&l=10&p=1')
            this.setState({ showLoader: false })
            if (res.status) {
                this.setState({ showLoader: false })
                Swal.fire({
                    icon: 'success',
                    text: res.messageCode,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                text: error,
                timer: 5000,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }


    render() {
        const { data, JOB_ID } = this.state;
        return (
            <React.Fragment >
                {data === undefined && <section className='pricing-area padding-top-100px padding-bottom-80px'>
                    <div className="container">
                        <div className='row'>
                            <div className='col-md-3 mt-3'>
                                <AsideRightMenu />
                            </div>
                            <div className='col-md-9'>
                                <Shimmer />
                            </div>
                        </div>
                    </div>
                </section>
                }
                {data !== undefined && <PostAJob
                    Data={this.state.data}
                    onSubmit={this.onSubmit}
                    JOB_ID={JOB_ID}
                    showLoader={this.state.showLoader}
                />}
            </React.Fragment>
        )
    }
}
